import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Layouts
import NonAuthLayout from '../Layouts/NonAuthLayout';
import VerticalLayout from '../Layouts/index';
import OnlyHeaderLayout from 'Layouts/OnlyHeaderLayout';

// Routes
import { authProtectedRoutes, publicRoutes, onlyHeaderRoutes, SHOW_HOME_PAGE } from './allRoutes';
import AuthProtected from './AuthProtected';
import Loader from 'Components/Common/Loader';

const Index = () => {
    const LoadingSpinner = () => (
        <div>
            <Loader />
        </div>
    );

    return (
        <React.Fragment>
            <Routes>
                {/* Public Routes */}
                <Route>
                    {publicRoutes.map((route: any, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <Suspense fallback={<LoadingSpinner />}>
                                    {/* Directly use route.component */}
                                    <NonAuthLayout>{route.component}</NonAuthLayout>
                                </Suspense>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                {/* Auth Protected Routes */}
                <Route>
                    {authProtectedRoutes.map((route: any, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected route={route}>
                                    <Suspense fallback={<LoadingSpinner />}>
                                        <VerticalLayout>{route.component}</VerticalLayout>
                                    </Suspense>
                                </AuthProtected>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                {/* Only Header Layout Routes */}
                <Route>
                    {onlyHeaderRoutes.map((route: any, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected route={route}>
                                    <Suspense fallback={<LoadingSpinner />}>
                                        <OnlyHeaderLayout>{route.component}</OnlyHeaderLayout>
                                    </Suspense>
                                </AuthProtected>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                {/* Global catch-all — must be last. Intentionally outside AuthProtected:
                    wrapping a path="*" route in AuthProtected (which has no privilege keys)
                    causes it to always clear localStorage and redirect to /login, which
                    blocks the home page from rendering at "/". */}
                <Route
                    path="*"
                    element={<Navigate to={SHOW_HOME_PAGE ? '/home' : '/login'} replace />}
                />
            </Routes>
        </React.Fragment>
    );
};

export default Index;
